var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCopyV216(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 2.5C7.184 2.5 6.26021 3.111 5.80371 4H18.75C19.4395 4 20 4.5605 20 5.25V18.1963C20.889 17.7403 21.5 16.816 21.5 15.75V5.25C21.5 3.734 20.266 2.5 18.75 2.5H8.25ZM5.25 5.5C3.734 5.5 2.5 6.734 2.5 8.25V18.75C2.5 20.266 3.734 21.5 5.25 21.5H15.75C17.266 21.5 18.5 20.266 18.5 18.75V8.25C18.5 6.734 17.266 5.5 15.75 5.5H5.25Z",
    fill: "#03F5AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.5C3.734 5.5 2.5 6.734 2.5 8.25V18.75C2.5 20.266 3.734 21.5 5.25 21.5H15.75C17.266 21.5 18.5 20.266 18.5 18.75V8.25C18.5 6.734 17.266 5.5 15.75 5.5H5.25Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopyV216);
export default __webpack_public_path__ + "static/media/ic_copy_v2_16.8675758626b1118bea7ce7be4f28a040.svg";
export { ForwardRef as ReactComponent };